module.exports = __webpack_public_path__ + "img/tipo-operacion.207b91a1.svg";